import { Controller } from "@hotwired/stimulus"
import { createElement } from "react"
import { createRoot } from "react-dom/client"
import { GuideCards } from "../components/guide/Card"

export default class extends Controller {
  static targets = ["grid", "loading", "error"]
  static values = { url: String, slugs: Array, savedPage: Boolean }

  connect() {
    this.root = createRoot(this.gridTarget)
    this.load()
  }

  disconnect() {
    this.request?.abort()
    this.root.unmount()
    this.root = null
  }

  async load() {
    this.request?.abort()
    const request = new AbortController()
    this.request = request
    this.setState("loading")

    try {
      const url = new URL(this.urlValue, window.location.origin)
      this.slugsValue.forEach(slug => url.searchParams.append("slugs[]", slug))
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        signal: request.signal
      })
      if (!response.ok) throw new Error(`Guide cards request failed: ${response.status}`)

      const { cards, labels } = await response.json()
      if (!Array.isArray(cards) || !labels) throw new Error("Invalid guide cards response")
      if (request.signal.aborted) return

      this.root.render(createElement(GuideCards, {
        cards,
        labels,
        savedPage: this.savedPageValue,
        onReady: () => {
          if (!request.signal.aborted) this.setState("ready")
        }
      }))
    } catch (error) {
      if (!request.signal.aborted) this.setState("error")
    }
  }

  setState(state) {
    this.element.dataset.state = state
    this.element.setAttribute("aria-busy", String(state === "loading"))
    this.loadingTarget.hidden = state !== "loading"
    this.errorTarget.hidden = state !== "error"
    this.dispatch("state")
  }
}
